/* eslint-disable complexity */
import React from 'react';
import { makeStyles } from 'design-system/styles';
import { DialogTitle } from 'design-system';
import Dialog, { DialogContent, DialogActions } from 'react-scale/components/design-system/Dialog';
import { Button } from 'design-system/Button';

export interface ProjectRoleResult {
  error: boolean;
  errorMessage: string;
  result: any;
}

interface IProjectRolesResultsPopupProps {
  isModalOpen?: boolean;
  hideModal: () => void;
  title?: string;
  results: ProjectRoleResult[];
}

const ProjectRolesResultsPopup = ({
  isModalOpen,
  hideModal,
  title,
  results,
}: IProjectRolesResultsPopupProps) => {
  const style = useStyles();

  const successQuantity = results.filter(r => !r.error).length;
  const errorQuantity = results.filter(r => r.error).length;

  return (
    <>
      <Dialog
        className="roles-results-popup"
        open={isModalOpen || false}
        onClose={() => {
          hideModal();
        }}
      >
        <DialogTitle>{title || 'Project Roles Results'}</DialogTitle>
        <DialogContent className={style.dialogContent}>
          <div className={style.resultsCounts}>
            <span className={style.successCount}>Success: {successQuantity}</span>
            {' / '}
            <span className={style.errorCount}>Error: {errorQuantity}</span>
          </div>
          <div className="flex flex-col gap-4">
            {results.map((result, i) =>
              result.errorMessage ? (
                <div key={result.errorMessage} className={style.errorItem}>
                  {i + 1 + '- '} {result.errorMessage}
                </div>
              ) : null,
            )}
          </div>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center' }}>
          <Button onClick={() => hideModal()}>Close</Button>
        </DialogActions>
      </Dialog>
      <style jsx global>{`
        .MuiPaper-root {
          overflow: visible !important;
        }
      `}</style>
    </>
  );
};

const useStyles = makeStyles(() => ({
  title: {
    fontSize: '20px',
    fontWeight: 'bold',
    padding: '5px',
  },
  dialogContent: {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    width: '500px',
  },
  errorItem: {
    marginTop: '4px',
    fontSize: '12px',
  },
  resultsCounts: {
    fontWeight: 600,
  },
  successCount: {
    color: 'var(--color-RemoGreen)',
  },
  errorCount: {
    color: 'var(--color-RemoRed)',
  },
}));

export default ProjectRolesResultsPopup;
